import { CanActivateFn } from '@angular/router';
import { inject } from '@angular/core';
import { RouteNavigationService } from '@services/route-navigation.service';

/** Remembers the wizard name requested via the `/configurator/wizard/:wizardName` for later usage */
export const rememberWizardNameGuard: CanActivateFn = (route) => {
  const wizardName = route.paramMap.get('wizardName');
  if (wizardName) {
    sessionStorage.setItem('pendingWizardName', wizardName);
  }
  return true;
};

/** The `/configurator/wizard/:wizardName` route has no page of its own. Once the user is authenticated
 * (by authorizedGuard), redirect to OpenProjectComponent, which will start the stored wizard by Name */
export const redirectToOpenProjectGuard: CanActivateFn = async () => {
  const routeNavigationService = inject(RouteNavigationService);
  await routeNavigationService.toOpenProject();
  return false;
};
